<template>
  <div>
    <header class="header">
      <div style="position: absolute;left: 16px;top: 17px;">
        <router-link :to="{name:'manage apps'}"><span class="path">我的应用 / </span></router-link>
        <router-link :to="{name:'manage app release',query:{appId:appInfo.appId,appName:appInfo.appName}}"><span
            class="path">我的机床 / </span></router-link>
        <span class="active">添加记录</span>
      </div>
    </header>

    <main class="main">
      <header class="main-header">
        添加发布
      </header>
      <article style="margin-top: 20px">

        <el-row style="width: 100%">
          <el-col :span="12" style="padding-right: 20px;border-right: rgba(234, 234, 234, 1) solid 2px;height: 100%">
            <div>必填信息</div>
            <el-form label-position="left" label-width="80px" style="position:relative;top: 30px" ref="releaseForm"
                     :rules="this.releaseRules" :model="releaseForm">
              <el-form-item label="版本" prop="version">
                <el-input v-model="releaseForm.version" placeholder="名称，20字以内"></el-input>
              </el-form-item>
              <el-form-item label="更新日志" prop="log[0]">
                <el-input v-model="releaseForm.log[0]" type="textarea" rows="5" placeholder="名称，200字以内" maxlength="200"
                          show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="上传文件">
                <el-upload
                    drag
                    :multiple="false"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :http-request="handleUpload">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12" style="padding-left: 20px;">
            <header>
              <div>规则限制</div>
              <div style="position: absolute;right: 0;top: 0;"
                   @click="createRoleDialogVisible = true;tempRuleForm = {}">
                <el-link type="primary">添加规则<i class="el-icon-circle-plus-outline el-icon--right"></i></el-link>
              </div>

              <el-dialog title="添加规则" :visible.sync="createRoleDialogVisible" width="40%">
                <el-form label-width="120px" :model="tempRuleForm">
                  <el-form-item label="类型">
                    <el-select placeholder="请选择" v-model="tempRuleForm.ruleName">
                      <el-option v-for="option in ruleTypeOptions" :key="option.value" :label="option.label"
                                 :value="option.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <IntegerRule v-if="tempRuleForm.ruleName === 'Integer'" @change="inputRule"></IntegerRule>
                  <StringRule v-if="tempRuleForm.ruleName === 'String'" @change="inputRule"></StringRule>
                  <VersionRule v-if="tempRuleForm.ruleName === 'Version'" @change="inputRule"></VersionRule>
                  <PercentageRule v-if="tempRuleForm.ruleName === 'Percentage'" @change="inputRule"></PercentageRule>
                </el-form>
                <div slot="footer">
                  <el-button @click="createRoleDialogVisible = false">取消</el-button>
                  <el-button type="primary" @click="handleCreateRule">添加</el-button>
                </div>
              </el-dialog>
            </header>
            <article style="margin-top: 15px">
              <div class="rule-card" v-for="(item,index) in releaseForm.config" :key="index">
                <section style="position: absolute;top: 26px;left: 20px">
                  <span style="color: rgba(51, 51, 51, 100); font-size: 14px;">原始参数名：{{ item.dataName }}</span>
                </section>
                <section style="position: absolute;top:26px;right: 16px;">
                  <el-image style="margin-right: 10px" :src="$store.state.image.modifyIcon"
                            @click="openModifyRuleDialog(item)"></el-image>
                  <el-image :src="$store.state.image.deleteIcon" style="cursor: pointer"
                            @click="releaseForm.config.splice(index,1)"></el-image>
                </section>
              </div>

              <el-dialog title="修改规则" :visible.sync="modifyRoleDialogVisible" width="40%">
                <el-form label-width="120px">
                  <el-form-item label="类型">
                    <el-select placeholder="请选择" v-model="tempRuleForm.ruleName">
                      <el-option v-for="option in ruleTypeOptions" :key="option.value" :label="option.label"
                                 :value="option.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <IntegerRule v-if="tempRuleForm.ruleName === 'Integer'" :rule="tempRuleForm"
                               @change="inputRule"></IntegerRule>
                  <StringRule v-if="tempRuleForm.ruleName === 'String'" :rule="tempRuleForm"
                              @change="inputRule"></StringRule>
                  <VersionRule v-if="tempRuleForm.ruleName === 'Version'" :rule="tempRuleForm"
                               @change="inputRule"></VersionRule>
                  <PercentageRule v-if="tempRuleForm.ruleName === 'Percentage'" :rule="tempRuleForm"
                                  @change="inputRule"></PercentageRule>
                </el-form>
                <div slot="footer">
                  <el-button type="primary" @click="createRoleDialogVisible = false">确定</el-button>
                </div>
              </el-dialog>
            </article>
          </el-col>
        </el-row>
      </article>
      <footer style="position: absolute;bottom: 22px;right: 32px">
        <el-button type="primary" @click="handleCreateRelease">提交</el-button>
      </footer>
    </main>
  </div>
</template>

<script>
import {upload, uploadToken, uploadWithToken} from "@/api/UploadApi";
import {createAppRelease} from "@/api/AppRelease";
import StringRule from "@/views/app/createRelease/StringRule";
import IntegerRule from "@/views/app/createRelease/IntegerRule";
import VersionRule from "@/views/app/createRelease/VersionRule";
import PercentageRule from "@/views/app/createRelease/PercentageRule";
import {Message} from "element-ui";
import {releaseRules} from "@/utils/common";

export default {
  name: "CreateRelease",
  components: {PercentageRule, VersionRule, IntegerRule, StringRule},
  data() {
    return {
      image: {
        addImage: require("@/assets/添 加.png")
      },
      createRoleDialogVisible: false,
      modifyRoleDialogVisible: false,
      ruleTypeOptions: [
        {label: '数字', value: 'Integer'},
        {label: '字符串', value: 'String'},
        {label: '版本', value: 'Version'},
        {label: '比例', value: 'Percentage'},
        {label: '自定义规则', value: 'Custom'},
      ],
      appInfo: {
        appId: this.$route.query.appId,
        appName: this.$route.query.appName
      },
      releaseForm: {
        appName: this.$route.query.appName,
        version: undefined,
        log: [],
        date: undefined,
        dlUrl: undefined,
        backupUrl: undefined,
        config: [],
      },
      tempRuleForm: {
        ruleName: undefined,
        priority: undefined
      },
      releaseRules: releaseRules
    }
  },
  methods: {
    inputRule(data) {
      this.tempRuleForm = {...this.tempRuleForm, ...data,};
    },
    handleCreateRule() {
      this.releaseForm.config.push(this.tempRuleForm)
      this.createRoleDialogVisible = false
    },
    handleUpload(args) {
      if (this.releaseForm.version == null) {
        this.$alert("请先输入版本信息")
        args.onError(new Error("把呢不能信息不存在"))
      } else {
        upload(this.appInfo.appName, this.releaseForm.version, args.file).then(res => {
          if (this.releaseForm.backupUrl) {
            this.releaseForm.backupUrl = this.releaseForm.dlUrl + "|" + res.data;
          } else {
            this.releaseForm.backupUrl = res.data;
          }
          args.onSuccess(res)
        }).catch(error => {
          args.onError(error)
        });

        uploadToken(this.appInfo.appName, this.releaseForm.version, args.file).then(res => {
          uploadWithToken(res, args.file).then(res2 => {
            this.releaseForm.dlUrl = res.data.host + "/" + res.data.key;
            args.onSuccess(res2)
          }).catch(err => {
            args.onError(err)
          });
        }).catch(error => {
          args.onError(error)
        });
      }
    },
    handleCreateRelease() {
      this.$refs['releaseForm'].validate(valid => {
        if (valid) {
          createAppRelease(this.releaseForm).then(() => {
            Message({
              message: '添加规则成功',
              type: "success",
              duration: 3 * 1000
            })
            this.$router.push({
              name: 'manage app release',
              query: {appId: this.appInfo.appId, appName: this.appInfo.appName}
            })
          })
        } else {
          return false
        }
      })
    },
    openModifyRuleDialog(item) {
      this.modifyRoleDialogVisible = true;
      this.tempRuleForm = item
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 56px;
  background: #f4f9ff;
}

.header .path {
  color: rgba(102, 102, 102, 100);
  font-size: 14px;
}

.header .active {
  color: rgba(51, 51, 51, 100);
  font-size: 16px;
}

.main {
  margin: 12px 16px;
  background: #ffffff;
  border-radius: 4px;
  min-height: calc(100vh - 44px - 56px - 24px - 50px);
  padding: 22px 32px;
  position: relative;
}

.main-header {
  border-bottom: rgba(234, 234, 234, 1) solid 2px;
  color: rgba(48, 49, 51, 100);
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 10px;
}

.rule-card {
  height: 74px;
  margin: 5px 0;
  background: #e2efff;
  border-radius: 8px;
}
</style>
